import { EnumSchema } from '../metadata-schema';

export const ExamencijfersUitzondering: EnumSchema = {
	"type": "string",
	"title": "ExamencijfersUitzondering",
	"enum": [
		"Regulier examencijfer",
		"Assistentenopleiding/Entreeopleiding",
		"VAVO-opleiding",
		"Vakmanschap/technologie-route",
		"Extraneus",
		"Uitgesloten van ROD-communicatie",
		"Niet geslaagd of afgewezen",
		"In eerder jaar geëxamineerd van gespreid examen"
	]
};
